module.exports = __webpack_public_path__ + "static/img/ios1.5.a1d47d90.jpg";